/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260430
*/

'use strict';
import { getUrlParam } from './ctssHtml.js';

const closeReport = () => {
    window.location.href = getUrlParam({ key: 'rUrl', dflt: '../' });
};

export { closeReport };

window.snRptViewrUtils = {
    closeReport
}